import React from "react";
import styles from "./Card.module.css";
import Button from "../Button/Button";
import { MdKeyboardArrowRight } from "react-icons/md";

interface CardProps {
  variant: "primary" | "secondary" | "tertiary" | "unknown";
  chipContent?: string;
  title: string;
  subtitle: string;
  buttonLabel: string;
  onButtonClick?: () => void;
  hoverContent?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({
  variant,
  chipContent,
  title,
  subtitle,
  buttonLabel,
  onButtonClick,
  hoverContent,
}) => {
  const handleCardClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent triggering the parent's onClick
    if (onButtonClick) {
      onButtonClick();
    }
  };

  return (
    <div
      className={`${styles.card} ${styles[variant]}`}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleCardClick();
        }
      }}
    >
      <div className={styles.top}>
        {chipContent && <div className={`${styles.chip} ${styles[`${variant}Chip`]}`}>{chipContent}</div>}
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.subtitle}>{subtitle}</p>
        {hoverContent && <div className={styles.hoverContent}>{hoverContent}</div>}
      </div>
      <Button variant={"text-underline"} fullWidth={true} className={styles.cardButton}
        rightIcon={<MdKeyboardArrowRight size={32} />}
        onClick={() => {
          if (onButtonClick) {
            onButtonClick();
          }
        }}>
        {buttonLabel}
      </Button>
    </div>
  );
};

export default Card;
